import { saveAs } from "file-saver";
import { toast } from "react-toastify";
import axios from "../Axios";
import { isValidUrl } from "../Utility";
import { Urls } from "../Urls";
import { STORAGE_ACCOUNT } from "../config/env.config";

const AZURE_CONTAINER_NAME = "private-container";

export const downloadFileToLocal = async (url, fileName = "") => {
  if (!url || !isValidUrl(url)) {
    console.error("downloadFile: Invalid or missing URL.");
    return;
  }

  if (fileName === "") {
    const link = document.createElement("a");

    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  } else {
    try {
      // extract file extension from the URL - ignore query params
      const urlParts = url.split("?");
      const path = urlParts[0];
      const extMatch = path.match(/\.(\w+)(?:$|\?)/);
      const extension = extMatch ? `.${extMatch[1]}` : "";

      // Append extension if not already present
      if (fileName !== "" && !fileName.endsWith(extension)) {
        fileName += extension;
      }

      const response = await fetch(url);
      if (!response.ok) throw new Error("Failed to fetch file.");

      const blob = await response.blob();
      saveAs(blob, fileName);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  }
};

export const getSignedDownloadUrl = async (filename) => {
  if (!filename) return null;

  try {
    const body = {
      action: "download",
      fileName: filename,
      accountName: STORAGE_ACCOUNT,
      containerName: AZURE_CONTAINER_NAME,
    };

    const { data } = await axios.post(Urls.lorriFileServiceNew, body);
    return data?.url || null;
  } catch (error) {
    console.error("Error fetching signed URL:", error);
    return null;
  }
};

/**
 * Fetches signed URL and downloads the file to local machine.
 */
export const DownloadFile = async (
  filename,
  toggleLoader,
  downloadedFileName
) => {
  if (!filename) return;

  toggleLoader && toggleLoader(true);

  try {
    const url = await getSignedDownloadUrl(filename);
    if (url) await downloadFileToLocal(url, downloadedFileName);
    else throw new Error("Failed to get signed URL");
  } catch (error) {
    console.error(error);
    toast.error("Failed to fetch Document");
  } finally {
    toggleLoader && toggleLoader(false);
  }
};
